module.exports = __webpack_public_path__ + "static/Rosa_Luxemburg_Foundation_logo.svg-318cd764fed39efa887543003ae38eff.png";